export interface SurveyQuestionFormModel {
    welcomeMessage: string;
    questions: SurveyQuestionModel[];
    endingMessage: string;
}
export interface SurveyQuestionModel {
    index?: number;
    question: string;
    options: SurveyQuestionOptionModel[];
    conditionEnabled: boolean;
    openEnded: boolean;
    flag: boolean;
    openEndedNextIndex: string;
}
export interface SurveyQuestionOptionModel {
    value: string;
    nextQuestionIndex: string;
}

export interface SurveyQuestionConditionOptionsModel {
    [k: number]: SurveyQuestionContionOption[];
}

export interface SurveyQuestionContionOption { 
    label: string; 
    conditionQuestionId: string; 
};

export type SurveyConditionalConfirmDialogType = 'reset' | 'delete' | 'discard' | 'undo';
export type SurveyConditionalQuestionIdType = number | 'next' | 'end';

export interface SurveyConditionalLogicOptionModel {
    text: string;
    url?: string;
    nextQuestion: string;
}
export interface SurveyConditionalLogicQuestionModel {
    flag: boolean;
    text: string;
    url?: string;
    openEndedFlag?: boolean;    
    nextQuestion?: string;
    options?: { [optionIndex: string]: SurveyConditionalLogicOptionModel };
}
export interface SurveyConditionalLogicLanguageModel {
    introText: string;
    endText: string;
    question: { [questionId: string]: SurveyConditionalLogicQuestionModel };
}

export interface SurveyConditionalLogicModel {
    _id?: string;
    deleteFlag?: boolean;
    surveyId: string;
    orgId: string;
    correlationId?: string;
    finalSave: boolean;
    finalSubmit: boolean;
    reason?: {[key:string]:string};
    language: { [language: string]: SurveyConditionalLogicLanguageModel; };
    percentage?: string;
}

export interface GetSurveyConditionalLogicResponse {
    metadata: { [descriptionKey: string]: any },
    data: SurveyConditionalLogicModel;
}